@if (readRole()) {
  <section class="flex flex-col gap-4">
    <div
      class="flex gap-2 items-center w-full border-b border-gray-300 *:p-2.5 *:text-sm *:w-[12.5rem] *:border-gray-300"
    >
      <button
        routerLink="/administration/accounting/sales"
        class="relative rounded border-b-0 border rounded-b-none rounded-bl-none rounded-br-none"
      >
        매출/매입 관리
        @if (segment() === 'sales') {
          <div
            class="bg-white h-px w-full absolute -bottom-[1px] right-0"
          ></div>
        }
      </button>
      <button
        routerLink="/administration/accounting/salary"
        class="relative rounded border-b-0 border rounded-b-none rounded-bl-none rounded-br-none"
      >
        급여 관리
        @if (segment() === 'salary') {
          <div
            class="bg-white h-px w-full absolute -bottom-[1px] right-0"
          ></div>
        }
      </button>
    </div>
    <router-outlet />
  </section>
} @else {
  <section class="flex flex-col gap-4">
    <div class="flex items-center justify-center w-full h-64">
      <p class="text-gray-500">접근 권한이 없습니다.</p>
    </div>
  </section>
}
